import { api } from "services"

export async function getCarrierMembers() {
  const { data } = await api.get("/carrier-members?asList=1")
  
  return data
}